import type { CombinedWarehouseOrderItemDto } from "@lib/ShiOneClient";
import type { StackedDrawerProps } from "shared-ui/src/components/detail-drawer/drawer-stack/types";
import IntegrationCenterDetailDrawerTransferIntegration from "@features/assets-feature/components/integration-center/IntegrationCenterDetailDrawerTransferIntegration";

interface Props extends StackedDrawerProps {
  details: CombinedWarehouseOrderItemDto | undefined;
}

export function StackedIntegrationCenterTransferIntegrationDrawer({
  open,
  onClose,
  onCloseAll,
  zIndex,
  details,
}: Props) {
  return (
    <IntegrationCenterDetailDrawerTransferIntegration
      open={open}
      onClose={onClose}
      onCloseAll={onCloseAll}
      zIndex={zIndex}
      details={details}
      isStackedDrawer
    />
  );
}
